import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { InternalLink } from '../../../../navigation/internal-link';

interface Props {
  children?: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
  to?: string;
  href?: string;
  isLogOut?: true;
}

export const DropdownItemWithIcon = (props: Props) => {
  return props.to ? (
    <RootInternalLink to={props.to}>
      <Icon>{props.icon}</Icon>
      {props.children}
    </RootInternalLink>
  ) : (
    <Root
      onClick={props.onClick}
      href={props.href}
      target="blank"
      isLogOut={props.isLogOut as boolean}
      id={props.isLogOut ? E2eTestElementId.LOGOUT : undefined}
    >
      <Icon>{props.icon}</Icon>
      {props.children}
    </Root>
  );
};

const commonStyles = `
  all: unset;
  cursor: pointer;
  height: 28px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  transition: background-color 200ms ease;
  &:first-child {
    border-radius: 4px 4px 0 0;
  }
  &:last-child {
    border-radius: 0 0 4px 4px;
  }
  &:hover {
    background-color: ${BouColor.PLATFORM_BG_GRAY};
  }
`;

const Root = styled.a<{ isLogOut: boolean }>`
  ${commonStyles}
  *,
  *:hover {
    ${props => props.isLogOut && `color: ${BouColor.TOOL_DANGER_RED}` && `fill: ${BouColor.TOOL_DANGER_RED}`}
  }
`;

const RootInternalLink = styled(InternalLink)`
  ${commonStyles}
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${BouColor.PLATFORM_ICON_GRAY};
  margin-right: 8px;
  > svg {
    height: 16px;
    fill: ${BouColor.PLATFORM_ICON_GRAY};
  }
`;
